import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/* Constants */
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';
/* Components */
import { GlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/global-search-link';
import { LinkIcon } from 'site-modules/shared/components/inventory/global-search/link-icon/link-icon';
import { LinkTitle } from 'site-modules/shared/components/inventory/global-search/link-title/link-title';

export const BaseGlobalSearchLink = memo(
  ({
    linkThumbComponent: LinkThumbComponent = LinkIcon,
    linkTitleComponent: LinkTitleComponent = LinkTitle,
    label = GlobalSearchLinkDefaultProps.label,
    ...rest
  }) => {
    return (
      <GlobalSearchLink {...rest}>
        <LinkThumbComponent {...rest} />
        <div className={classnames({ 'd-flex align-items-center': !label })}>
          <LinkTitleComponent {...rest} />
          {!!label && <span className="medium text-cool-gray-40">{label}</span>}
        </div>
      </GlobalSearchLink>
    );
  }
);

BaseGlobalSearchLink.displayName = 'BaseGlobalSearchLink';

BaseGlobalSearchLink.propTypes = {
  ...GlobalSearchLinkPropTypes,
  linkThumbComponent: PropTypes.elementType,
  linkTitleComponent: PropTypes.elementType,
};
